module.exports = "pegasus/assets/themelp1/travel/106.png";